import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2ddc9c9a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=2ddc9c9a&prod&scoped=true&lang=scss"
import style1 from "./home.vue?vue&type=style&index=1&id=2ddc9c9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ca1684712bc6b92d0f967ca402105836/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc9c9a",
  null
  
)

export default component.exports